/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IPaymentsState, PaymentActionsTypes } from "./types";
import { Consts } from ".";

export const initialState: IPaymentsState = {
  offers: {},
};

export const paymentsReducer = (
  state = initialState,
  action: PaymentActionsTypes
): IPaymentsState => {
  switch (action.type) {
    case Consts.GET_OFFERS: {
      return {
        ...state,
        offers: {
          Initialized: true,
          ...state.offers,
          IsProcessing: true,
          Error: undefined,
          Completed: false,
        },
      };
    }
    case Consts.GET_OFFERS_SUCCESS: {
      return {
        ...state,
        offers: {
          Initialized: true,
          Data: action.payload,
          IsProcessing: false,
          Error: undefined,
          Completed: true,
        },
      };
    }
    case Consts.GET_OFFERS_FAILURE: {
      return {
        ...state,
        offers: {
          ...state.offers,
          Initialized: true,
          IsProcessing: false,
          Error: action.error,
          Completed: true,
        },
      };
    }
    default:
      return state;
  }
};
